<template>
    <div class="headerbar">
        <a class='brand-logo'>
            <img src="../assets/icons/logo-dialogloop-with-title.svg">
        </a>
        <a class="dropdown-button">
            <img v-if="user.pictureUrl" v-bind:src="user.pictureUrl" v-on:click="toggleAccountMenu">
            <img v-else src="../assets/icons/anonymous.svg" v-on:click="toggleAccountMenu">   
        </a>
        <div class="dropdown-menu" v-if="menuOpen">
            <accountmenu :user="user" :service="service" v-on:closeMenu="closeMenu()"></accountmenu>
        </div>         
    </div>
</template>

<script>

import AccountMenu from '@/components/AccountMenu';

export default{
    components: {
        accountmenu: AccountMenu
    },

    props: {
        user: Object,
        service: Object
    },

    data() {
        return {
            menuOpen: false,
            toggled: false
        };
    },

    methods: {
        toggleAccountMenu() {
           /* if (!this.toggled && !this.menuOpen) {
                this.toggled = true;
                this.menuOpen = true;
            } else if (this.toggled && !this.menuOpen) {
                this.toggled = false;
            }*/
            this.menuOpen = !this.menuOpen;
        }

        /*closeMenu() {
            this.menuOpen = false;  
        }*/
    }
};

</script>

<style lang="scss">

.headerbar
{
    height: 64px;
    line-height: 64px;
    color: #fff;
    background-color: #000000;
    width: 100%;
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);

    .brand-logo
    {
        padding: 0;
        transform: none;
        position: relative;
        color: #fff;
        display: inline-block;
        font-size: 2.1rem;
        white-space: nowrap;
        height: 64px;

        img
        {
            margin-top: -25px;
            height: 115px;
        }
    }

    .dropdown-button
    {
        float: right !important;
        padding: 10px 15px 0 15px;
        cursor: pointer;
        height: 40px;

        img
        {
            position: relative;
            height: 32px;
            width: 32px;
            z-index: 2;
            border-radius: 50%;
        }
    }
    .dropdown-menu {
    margin-top: -52px;
    }
}

</style>



// WEBPACK FOOTER //
// HeaderBar.vue?f9a32f28